import { render, staticRenderFns } from "./radioPage.vue?vue&type=template&id=b353b5fc&scoped=true"
import script from "./radioPage.vue?vue&type=script&lang=js"
export * from "./radioPage.vue?vue&type=script&lang=js"
import style0 from "./radioPage.vue?vue&type=style&index=0&id=b353b5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b353b5fc",
  null
  
)

export default component.exports